import { render } from "./Heading.vue?vue&type=template&id=5ff0bb24"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"
script.render = render

export default script